import { AlertCircle, CheckCircle2 } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableRowHeader,
} from '../ui/table';
import type { CsvValidatedRow, DataPreviewTableProps } from './types';

export function DataPreviewTable({ previewRows, columnHeaders, totalRows }: DataPreviewTableProps) {
  return (
    <>
      <div className="h-[350px] rounded-md border overflow-auto">
        <Table caption="Uploaded file data preview">
          <TableHeader>
            <TableRow>
              <TableHead className="w-16">#</TableHead>
              <TableHead className="w-20">Status</TableHead>
              {columnHeaders.map((header) => (
                <TableHead key={header} className="min-w-[120px]">
                  {header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {previewRows.map((row: CsvValidatedRow) => (
              <TableRow
                key={row.row_number}
                className={row.is_valid ? '' : 'bg-red-50/50 dark:bg-red-950/40'}
              >
                <TableRowHeader className="font-medium">{row.row_number}</TableRowHeader>
                <TableCell>
                  {row.is_valid ? (
                    <CheckCircle2 className="h-4 w-4 text-emerald-600" />
                  ) : (
                    <AlertCircle className="h-4 w-4 text-red-600" />
                  )}
                </TableCell>
                {columnHeaders.map((header) => (
                  <TableCell key={header} className="max-w-[200px] truncate">
                    {row.original_data[header] || '-'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {previewRows.length < totalRows && (
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Showing {previewRows.length} of {totalRows} rows
        </p>
      )}
    </>
  );
}
